'use strict';

exports.__esModule = true;
exports.default = exports.hasAnyError = undefined;

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _immutable = require('immutable');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _extractPropertyFromState = require('./extractPropertyFromState');

var _extractPropertyFromState2 = _interopRequireDefault(_extractPropertyFromState);

var _hasErrors2 = require('./hasErrors');

var _hasErrors3 = _interopRequireDefault(_hasErrors2);

var _validateField = require('./validateField');

var _validateField2 = _interopRequireDefault(_validateField);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasAnyError = exports.hasAnyError = function hasAnyError(errors) {
  return !(0, _keys2.default)(errors).reduce(function (acc, error) {
    return acc || errors[error];
  }, false);
};

var Form = function (_Component) {
  (0, _inherits3.default)(Form, _Component);

  function Form() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.fields = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Form.prototype.getChildContext = function getChildContext() {
    return {
      onionIsValid: this.isFormValid.bind(this),
      onionFieldRegister: this.fieldRegister.bind(this),
      onionFormName: this.props.name,
      onionLiveValidate: this.liveValidate.bind(this),
      onionOnSubmit: this.onSubmit.bind(this)
    };
  };

  Form.prototype.onSubmit = function onSubmit(event) {
    event.preventDefault();
    return this._submit();
  };

  Form.prototype.liveValidate = function liveValidate() {
    var name = this.props.name;
    var getState = this.context.store.getState;


    var liveValidationsEnabled = (0, _extractPropertyFromState2.default)(getState(), name, 'liveValidation');

    var fieldsToValidate = (0, _keys2.default)(this.fields).filter(function (fieldName) {
      return liveValidationsEnabled[fieldName];
    });

    return this.validate(fieldsToValidate);
  };

  Form.prototype.fieldRegister = function fieldRegister(fieldName, field) {
    var name = this.props.name;
    var _context$store = this.context.store,
        getState = _context$store.getState,
        dispatch = _context$store.dispatch;


    if (field) {
      this.fields[fieldName] = field;

      // Try if field has already data in store
      if (_immutable.Map.isMap(getState().onionForm.getIn(['fields', name, fieldName]))) {
        // Lets try to validate it!
        var errors = this._getValidationErrors(this._allFieldNames());
        if (!hasAnyError(errors)) {
          // Save these errors to state just to change it so submit button will refresh
          dispatch((0, _actions.setMultipleFields)(name, 'onInitError', errors));
        }
      } else {
        // It has no footprint so register it
        dispatch((0, _actions.registerField)(name, fieldName));
      }
    } else {
      delete this.fields[fieldName];
    }
  };

  Form.prototype.formValidate = function formValidate() {
    this._enableAllFieldsLiveValidation();

    return this.validate(this._allFieldNames());
  };

  Form.prototype.isFormValid = function isFormValid() {
    var errors = this._getValidationErrors(this._allFieldNames());

    return hasAnyError(errors);
  };

  Form.prototype.validate = function validate(fieldsToValidate) {
    var name = this.props.name;
    var dispatch = this.context.store.dispatch;


    return dispatch((0, _actions.setMultipleFields)(name, 'error', this._getValidationErrors(fieldsToValidate)));
  };

  Form.prototype._submit = function _submit() {
    var _props = this.props,
        name = _props.name,
        onError = _props.onError,
        onSubmit = _props.onSubmit;

    var values = this._getValues();
    var errors = this._getErrors();

    // check for validation errors
    if (!this._isValid()) {
      if (typeof onError === 'function') onError({ name: name, errors: errors });
      return false;
    }

    if (typeof onSubmit === 'function') onSubmit({ name: name, values: values });
    return true;
  };

  Form.prototype._isValid = function _isValid() {
    var name = this.props.name;
    var dispatch = this.context.store.dispatch;

    // Cleanup all previous errors

    dispatch((0, _actions.clearFormProperty)(name, 'error'));

    // Validate all fields
    this.formValidate();

    return !this._hasErrors();
  };

  Form.prototype._hasErrors = function _hasErrors() {
    var name = this.props.name;
    var getState = this.context.store.getState;


    return (0, _hasErrors3.default)(getState(), name);
  };

  Form.prototype._getErrors = function _getErrors() {
    var name = this.props.name;
    var getState = this.context.store.getState;


    return (0, _extractPropertyFromState2.default)(getState(), name, 'error');
  };

  Form.prototype._getValues = function _getValues() {
    var name = this.props.name;
    var getState = this.context.store.getState;


    return (0, _extractPropertyFromState2.default)(getState(), name, 'value');
  };

  Form.prototype._extractValidationsFromField = function _extractValidationsFromField(fieldName) {
    var field = this.fields[fieldName];
    var validations = this.props.validations;

    if (!field || typeof field.validations !== 'function' || !field.props) return validations[fieldName] || [];

    return (validations[fieldName] || []). // 1. validations from form level <Form validations={{'name': [isRequired()]}} />
    concat(field.validations() || []) // 2. add validations from createField level createField('name', {}, [isRequired()])
    .concat(field.props.validations || []); // 3. add validations from instance level <Field validations=[isRequired()] />
  };

  Form.prototype._getValidationErrors = function _getValidationErrors(fieldsToValidate) {
    var _this2 = this;

    var values = this._getValues();

    return fieldsToValidate.reduce(function (acc, fieldName) {
      var _extends2;

      return (0, _extends5.default)({}, acc, (_extends2 = {}, _extends2[fieldName] = (0, _validateField2.default)(values[fieldName], _this2._extractValidationsFromField(fieldName), values), _extends2));
    }, {});
  };

  Form.prototype._enableAllFieldsLiveValidation = function _enableAllFieldsLiveValidation() {
    var name = this.props.name;
    var dispatch = this.context.store.dispatch;


    return dispatch((0, _actions.setMultipleFields)(name, 'liveValidation', this._allFieldNames().reduce( // this will create { field1: true, field2: true, ...}
    function (acc, field) {
      var _extends3;

      return (0, _extends5.default)({}, acc, (_extends3 = {}, _extends3[field] = true, _extends3));
    }, {})));
  };

  Form.prototype._allFieldNames = function _allFieldNames() {
    var validations = this.props.validations;

    return (0, _keys2.default)(this.fields).concat((0, _keys2.default)(validations));
  };

  Form.prototype.render = function render() {
    var _props2 = this.props,
        children = _props2.children,
        method = _props2.method;
    var onionFormName = this.context.onionFormName;

    var props = {
      method: method,
      onSubmit: this.onSubmit.bind(this)
    };

    return onionFormName ? _react2.default.createElement(
      'div',
      null,
      children
    ) : _react2.default.createElement(
      'form',
      props,
      children
    );
  };

  return Form;
}(_react.Component);

Form.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.node)]).isRequired,
  method: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  onError: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  validations: _propTypes2.default.object
};
Form.contextTypes = {
  onionFormName: _propTypes2.default.string,
  store: _propTypes2.default.object.isRequired
};
Form.childContextTypes = {
  onionIsValid: _propTypes2.default.func.isRequired,
  onionFieldRegister: _propTypes2.default.func.isRequired,
  onionFormName: _propTypes2.default.string.isRequired,
  onionLiveValidate: _propTypes2.default.func.isRequired,
  onionOnSubmit: _propTypes2.default.func.isRequired
};
Form.defaultProps = {
  method: 'POST',
  validations: {}
};
exports.default = Form;